import React from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MyBreadcrumb = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Split the path into segments and filter to start from '/settings'
  const pathnames = location.pathname
    .split("/")
    .filter((segment) => segment)
    .filter((segment, index, arr) => arr[0] === "settings" || index > 0);

  // Build breadcrumb items
  const breadcrumbItems = pathnames.map((value, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
    const isLast = index === pathnames.length - 1;

    return {
      title: isLast ? (
        <span>{value.replace(/-/g, " ")}</span>
      ) : (
        <Link to={routeTo}>{value.replace(/-/g, " ")}</Link>
      ),
    };
  });

  // Add "Home" as the root item
  breadcrumbItems.unshift({
    title: <Link to="/">{t("breadcrumb_home")}</Link>,
  });

  return <Breadcrumb items={breadcrumbItems} />;
};

export default MyBreadcrumb;
